/* Global Styles */
.drawer :global .MuiPaper-root {
    box-shadow: var(--box-shadow-base);
    color: var(--text-black);
}

.drawer :global .MuiDrawer-paperAnchorBottom {
    border-top-left-radius: var(--spacing-20);
    border-top-right-radius: var(--spacing-20);
}
